/**
 * Mükerrer satır tespiti — İŞARETLER, silmez.
 *
 * Bu dosya bir veri kaybı hatasından doğdu. Önceki kod aynı gün + aynı tutar
 * + açıklamanın İLK 15 KARAKTERİ eşleşen satırları sessizce atıyordu:
 *
 *   "25/12 Market alisverisi Migros    -250,00"
 *   "25/12 Market alisverisi Carrefour -250,00"   <- biri kayboluyordu
 *
 * İkisi ayrı harcamadır. Defterden bir kaydın eksilmesi, kullanıcının fark
 * etmediği bir hatadır — sessiz olduğu için en kötüsü.
 *
 * Aynı gün aynı tutarda iki kahve de gerçekten olur. Bunun kopya mı yoksa
 * iki ayrı işlem mi olduğunu bilemeyiz; bilebilecek olan kullanıcıdır.
 * Bize düşen, fark ettiğimizi söylemek.
 */

/** Karşılaştırmaya giren alanlar. Açıklama TAMAMIYLA kullanılır. */
export interface Comparable {
  readonly date: string;
  readonly amount: number;
  readonly type: string;
  readonly note: string;
}

function key(r: Comparable): string {
  return [r.date, r.amount.toFixed(2), r.type, r.note].join(' ');
}

/**
 * Her satır için "bundan öncesinde birebir aynısı var mı".
 *
 * İlk görülen satır her zaman false döner: kopya olan sonraki tekrardır,
 * ilki değil. Böylece işaretlenen satır, kullanıcının silmeyi düşüneceği
 * satır olur.
 */
export function duplicateFlags(rows: readonly Comparable[]): boolean[] {
  const seen = new Set<string>();
  return rows.map((r) => {
    const k = key(r);
    if (seen.has(k)) return true;
    seen.add(k);
    return false;
  });
}
